import { backendApi } from 'api/api';
import APIErrorsHandlingUtils from 'utils/APIErrorsHandlingUtils';

/**
 * The e-phan competition calendar is synced into our own database, so the list
 * pages never talk to e-phan. Only the figures that move between syncs are read
 * live, and through our backend rather than straight from the browser: e-phan
 * budgets 300 calls a minute per IP, and one cached call per minute on our side
 * is cheaper than one per visitor.
 */
export default class EphanCompetitionsService {
  static async getLiveRegistration(ephanId) {
    const [error, data] = await backendApi.get(`/ephan/competitions/${ephanId}/live`);

    if (error) {
      return { result: null, error: APIErrorsHandlingUtils.handleErrors(error) };
    }

    // strapi-plugin-transformer is configured to drop the `data` wrapper, but it
    // is a response transform we do not control, so accept the payload either way.
    return { result: data?.data ?? data ?? null, error: null };
  }
}
